/**
 * Rebuy Widget Customizations
 * 
 * - Disables SmartCart (using theme's cart drawer instead)
 * - Refreshes cart drawer when products are added via Rebuy
 * - Re-initializes Rebuy widgets on cart changes (for empty cart state)
 * - Removes Rebuy's default CSS (custom styles in base.css)
 */

(function() {
  if (window.RebuyCustomizerLoaded) return;
  window.RebuyCustomizerLoaded = true;

  // Disable Rebuy SmartCart - we use the theme's cart drawer
  document.addEventListener('rebuy:smartcart.ready', () => {
    if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
      Rebuy.SmartCart.destroy();
    }
  });

  // Re-init Rebuy on cart changes (handles empty cart state)
  document.addEventListener('rebuy:cart.change', () => {
    setTimeout(() => {
      if (typeof Rebuy !== 'undefined') Rebuy.init();
    }, 100);
  });

  // Re-init Rebuy on theme cart updates (catches section re-renders)
  document.addEventListener('cart:update', () => {
    setTimeout(() => {
      if (typeof Rebuy !== 'undefined') Rebuy.init();
    }, 200);
  });

  // Watch for Rebuy widget containers added to DOM (for empty cart state)
  const widgetObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (node.matches?.('[data-rebuy-id]') || node.querySelector?.('[data-rebuy-id]'))) {
          setTimeout(() => {
            if (typeof Rebuy !== 'undefined') Rebuy.init();
          }, 50);
          return;
        }
      }
    }
  });
  widgetObserver.observe(document.body, { childList: true, subtree: true });

  // Intercept fetch to refresh the cart ONLY for Rebuy's own adds.
  // The theme's native ATC, the custom-subscription block, and Loop bundle adds all POST with
  // `sections` and dispatch their own cart:update. Bridging those double-fires and races the Loop
  // bundle's multi-line add (which broke WOO add). So we only bridge a /cart/add that does NOT
  // carry `sections` — i.e. a genuine Rebuy add (Rebuy doesn't send a sections param).
  const originalFetch = window.fetch;
  function rebuyAddCarriesSections(options) {
    try {
      const b = options && options.body;
      if (!b) return false;
      if (typeof b === 'string') return b.indexOf('sections') !== -1;
      if (typeof FormData !== 'undefined' && b instanceof FormData) return b.has('sections');
      if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) return b.has('sections');
    } catch (e) {}
    return false;
  }
  window.fetch = function(url, options) {
    const urlString = typeof url === 'string' ? url : url.toString();
    const isRebuyAdd = urlString.includes('/cart/add') && !rebuyAddCarriesSections(options);

    return originalFetch.apply(this, arguments).then(response => {
      if (isRebuyAdd && response.ok) {
        setTimeout(() => {
          const ci = document.querySelector('cart-items-component[data-section-id]');
          const sectionId = ci?.dataset?.sectionId;
          if (!sectionId) return;
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          // Section Rendering API returns { [sectionId]: "<html>" } with the populated cart.
          originalFetch(root + '?sections=' + encodeURIComponent(sectionId), { headers: { 'Cache-Control': 'no-cache' } })
            .then(r => r.json())
            .then(sections => {
              // Dispatch first so Rebuy re-inits + the shipping bar / cart bubble update.
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { data: { sections: sections, itemCount: undefined } }
              }));

              // The morph alone does NOT repopulate the drawer's cart-items-component (verified
              // in-browser), so explicitly replace the cart items + clear the empty-state class.
              const html = sections[sectionId];
              if (html) {
                const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items-component');
                const current = document.querySelector('cart-items-component');
                if (fresh && current) {
                  import('@theme/morph')
                    .then((m) => {
                      m.morph(current, fresh);
                      // DOM-inserted scripts don't auto-execute — re-run the guarded cart-products inline
                      // init so the subscribe-toggle listener binds (no-op if it already ran).
                      current.querySelectorAll('script:not([src])').forEach((old) => {
                        const s = document.createElement('script');
                        s.textContent = old.textContent;
                        old.replaceWith(s);
                      });
                    })
                    .catch(() => current.replaceWith(fresh));
                }
              }
              originalFetch(root + 'cart.js', { headers: { 'Cache-Control': 'no-cache' } })
                .then(r => r.json())
                .then(cart => {
                  const dlg = document.querySelector('dialog.cart-drawer__dialog');
                  if (dlg) dlg.classList.toggle('cart-drawer--empty', (cart.item_count || 0) === 0);
                });

              // Scroll cart drawer to top after adding product
              setTimeout(() => {
                const cartItems = document.querySelector('.cart-drawer__items');
                if (cartItems) {
                  cartItems.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }, 150);
            });
        }, 100);
      }
      return response;
    });
  };

  // Remove Rebuy's default CSS to use our custom styles
  function removeRebuyCss() {
    document.querySelectorAll('link[href*="rebuyengine.com"]').forEach(el => el.remove());
    document.querySelectorAll('style[id*="rebuy"], style[id="smart-cart-style"]').forEach(el => el.remove());
  }
  
  removeRebuyCss();
  
  // Observe for dynamically added Rebuy stylesheets
  const cssObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.tagName === 'LINK' && node.href?.includes('rebuyengine.com')) {
          node.remove();
        }
        if (node.tagName === 'STYLE' && node.id && (node.id.includes('rebuy') || node.id === 'smart-cart-style')) {
          node.remove();
        }
      }
    }
  });
  cssObserver.observe(document.head, { childList: true });
})();
